 
import { motion } from "framer-motion";

import './ExploreCard.scss'
import { fadeIn } from "../utils/motion";
import { images } from "../constants";



const ExploreCard = ({id, imgUrl,description, title, index, active, handleClick}) => {

 


  return (
   <motion.div
   variants={fadeIn('right', 'spring', index * 0.5, 0.75)}
 
   className= {`app__explore_card ${active === id ? 'style2' : 'style'}  `}
   onClick={() => handleClick(id)}
   >
   
    
    <img
      className=" app__explore_card-img"
      src={imgUrl}
      alt={title}
      
    />

    <p className=" app__explore_card-img-p p-text">{description}</p>

    
   
    


    
      {
        active !== id ? (
          <h3 className="app__explore_card-h3">
            {title}
          </h3>
        ): (
          <div className="app__explore_card-div">
            
            <div className="app__explore_card-div_div">
              <img 
              className="app__explore_card-div_div-img"
              src= {images.headset}
              alt="headset"
              />


            </div>


            {/* <p className="app__explore_card-div-p">
              Enter for more details
            </p> */}
            <h2 className="app__explore_card-div-h2">
              {title}
            </h2>
          </div>
        )
      }
   </motion.div>
)
}

export default ExploreCard;
